import { CreateSigningAppointmentRequest } from '../../../../../types/signingAppointment/CreateSigningAppointmentRequest';
import { eSigningAppointmentStatus } from '../../../../../types/signingAppointment/eSigningAppointmentStatus';
import { eSigningMethod } from '../../../../../types/signingAppointment/eSigningMethod';
import {
  eCreateSigningAppointmentFormDataOwnerTypes,
  getConsumerTypeFromFormDataOwnerType,
} from '../../../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';
import { generateAppointmentOptions } from '../01_detailsStep/detailsForm/utilities/generateTimeSlots';
import { ISignerResponse } from 'types/signingAppointment/ISignerResponse';

export interface CreateSigningAppointmentFormData
  extends Omit<CreateSigningAppointmentRequest, 'status' | 'ownerType'> {
  ownerType: eCreateSigningAppointmentFormDataOwnerTypes;
}

export const convertToCreateSigningAppointmentRequest = (
  formData: CreateSigningAppointmentFormData,
  markAsDraft?: boolean
): CreateSigningAppointmentRequest => {
  const isSignatureSyncAppointment =
    formData.signingMethod === eSigningMethod.notaryOnly ? formData.isSignatureSyncAppointment : false;
  const isDigitalSchedulingDraft = markAsDraft;

  const ownerType = getConsumerTypeFromFormDataOwnerType(formData.ownerType);
  const signers = (formData.signers ?? []).map((signer) => {
    const { personId, signatoryId, ...rest } = signer as ISignerResponse & { signatoryId?: string };
    return {
      ...rest,
      phoneNumber: signer.phoneNumber || null,
      email: signer.email || null,
      middleName: signer.middleName || null,
    };
  });

  // clearing address based on signer will provide location selection
  const signerWillProvideLocation = formData.signerWillProvideLocation;
  let address = !signerWillProvideLocation ? formData.address : null;

  // new use case to handle signer will select from range
  const signerSelectsFromRange = formData.signerSelectsFromRange;

  if (signerSelectsFromRange) {
    // generate time options
    const { dssDate, dssDateRangeEnd, dssDateRangeStart, dssStartTime, dssEndTime, isDssDateRange } = formData;
    const dssAppointmentOptions = generateAppointmentOptions({
      signerSelectsFromRange,
      dssDate,
      dssDateRangeEnd,
      dssDateRangeStart,
      dssStartTime,
      dssEndTime,
      isDssDateRange,
    });

    return {
      ...formData,
      address,
      dssAppointmentOptions,
      isDigitalSchedulingDraft,
      isSignatureSyncAppointment,
      ownerType,
      signers: signers as ISignerResponse[],
      status: eSigningAppointmentStatus.Requested,
    };
  }

  return {
    ...formData,
    address,
    isDigitalSchedulingDraft,
    isSignatureSyncAppointment,
    ownerType,
    signers: signers as ISignerResponse[],
    status: eSigningAppointmentStatus.Requested,
  };
};
